import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Observable, of } from 'rxjs';
import { map, switchMap, takeUntil } from 'rxjs/operators';
import { Destroyer } from 'src/app/core/abstract/destroyer';
import { CustomField, NUMBER_FORMATS } from 'src/app/core/models/custom-fields.models';
import { CustomFieldsStoreService } from 'src/app/core/store/services/custom-fields-store.service';
import { EntityFactory } from 'src/app/core/store/services/entity.factory';
import { CustomFieldDialogResult } from 'src/app/shared/components/custom-fileds/custom-field-dialog/types';

@Component({
  templateUrl: './number-field.component.html',
  styleUrls: ['./number-field.component.scss'],
  standalone: false,
})
export class CreateCustomNumberFieldComponent extends Destroyer implements OnInit {
  public numberFormats = NUMBER_FORMATS;

  public form = new UntypedFormGroup({
    label: new UntypedFormControl(void 0, { validators: [Validators.required] }),
    description: new UntypedFormControl(void 0),
    validation: new UntypedFormControl(void 0),
    orderIndex: new UntypedFormControl(void 0),
    max: new UntypedFormControl(void 0),
    format: new UntypedFormControl(void 0),
  });

  constructor(
    private entityFactory: EntityFactory,
    private customFieldsStore: CustomFieldsStoreService,
    private dialogRef: MatDialogRef<CreateCustomNumberFieldComponent, CustomFieldDialogResult>,
    @Inject(MAT_DIALOG_DATA) public field: Partial<CustomField> | undefined,
  ) {
    super();
  }

  public ngOnInit(): void {
    if (this.field) {
      this.form.patchValue(this.field);
    }
  }

  public close(): void {
    this.dialogRef.close({ done: false });
  }

  public done(): void {
    if (!this.form.valid) return;

    this.getOrCreate()
      .pipe(
        map((field) => ({ ...field, ...this.form.value })),
        switchMap((field) => this.customFieldsStore.save(field)),
        takeUntil(this.destroy$),
      )
      .subscribe((field) => {
        this.dialogRef.close({ done: true, field });
      });
  }

  public selectPreset(field: Partial<CustomField>) {
    this.form.patchValue({ ...this.form.value, ...field });
  }

  private getOrCreate(): Observable<Partial<CustomField>> {
    const field = this.field;

    if (field && field.id) {
      return of(field);
    }

    return this.entityFactory.createCustomField(field);
  }
}
